import { useId } from 'react';

/**
 * Mehrutherm brand mark: sun over rolling wheat hills, clay ground.
 *
 * Geometry mirrors public/favicon.svg exactly, at 1/32 the scale. Rounded here
 * because it sits inline as a badge, where the favicon is left square for the
 * browser, OS, or Plaid to mask however they like.
 *
 * Colors are literals rather than theme tokens: this is the brand, so it holds
 * on the dark sidebar and the light login card alike.
 */
export function BrandMark({ className }: { className?: string }) {
  // Scoped so two marks on one page can't collide on the clip path id.
  const clipId = useId();

  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true" focusable="false">
      <defs>
        <clipPath id={clipId}>
          <rect width="32" height="32" rx="8" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        <rect width="32" height="32" fill="#c9701c" />
        <circle cx="11" cy="11" r="3.5" fill="#fbf4ed" />
        <path
          d="M-1 24.5 C5 19.5, 11.5 22.5, 16 20.25 C21.5 17.5, 26 23.5, 33 18.75 L33 33 L-1 33 Z"
          fill="#fbf4ed"
        />
      </g>
    </svg>
  );
}
